import { differenceInDays, format } from "date-fns";
import moment from "moment";
import numeral from "numeral";
import Content from "../components/leasing.c.content";
import Button from "../components/leasing.c.button";
import { useContext, useEffect, useState } from "react";
import { ReversePaymentContext } from "components/Leasing/context/leasing.ctx.reversePayment";
import { preLateColor } from "../constrant/leasing.ct";
import {
  getAmountPlusReturnCarFee,
  getDifferenceInDays,
  round,
} from "../utils/leasing.u";

const FootageFeeData = ({
  loan,
  setOpenModal,
  date,
  interest,
  setTotalCancel,
  totalCancel,
}) => {
  const [open, setOpen] = useState(true);
  const { setOpenReverse } = useContext(ReversePaymentContext);

  useEffect(() => {
    if (setTotalCancel) {
      setTotalCancel(getTotalFee() + diffTotalVat());
    }
  }, [setTotalCancel, loan, date]);

  const getNumber = (number) => {
    if (number >= 0) {
      return numeral(number).format("0,0.00");
    }
    return 0;
  };

  const getTotalFee = () => {
    if (loan?.total_fee === 0) return 0;
    let total_fee =
      loan?.total_fee +
        getAmountPlusReturnCarFee(
          loan,
          date,
          interest?.RETURN_CAR,
          interest?.RETURN_CAR_DATE
        ) || 0;
    return total_fee - loan?.total_fee_vat || 0;
  };

  const getTotalRemain = () => {
    return loan?.total_fee === 0
      ? 0
      : getTotalFee() + diffTotalVat() - loan?.paidTotalFee || 0;
  };

  const getFixedTotal = () => {
    return loan?.break_fee + loan?.cancel_total || 0;
  };

  const diffTotal = () => {
    return getTotalFee() - getFixedTotal();
  };

  const diffTotalVat = () => {
    return round(diffTotal() * 0.07, 2);
  };

  return (
    <div className="bg-white px-1 py-2">
      <div className="flex flex-row justify-between p-2">
        <div className="font-bold text-lg text-coolGray-700 flex space-x-2">
          <div>ข้อมูลค่าธรรมเนียม</div>
          <div className={preLateColor}>
            <div className="flex flex-col">
              <div>
                ({getNumber(loan?.paidTotalFee)} /{" "}
                {getNumber(getTotalFee() + diffTotalVat())}) คงเหลือ{" "}
                {getNumber(getTotalRemain())} บาท
              </div>
              <div>
                ({getNumber(getFixedTotal())} + {getNumber(diffTotal())} +{" "}
                {diffTotalVat() + " ภาษี"}) {interest?.RETURN_CAR_DATE || 0}/
                {loan?.loan_status === "DONE"
                  ? 0
                  : getDifferenceInDays(
                      new Date(loan?.breakFeeDate),
                      new Date(date)
                    ) || 0}{" "}
                วัน
              </div>
            </div>
          </div>
        </div>
        {open ? (
          <svg
            onClick={() => setOpen(false)}
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M5 15l7-7 7 7"
            />
          </svg>
        ) : (
          <svg
            onClick={() => setOpen(true)}
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M19 9l-7 7-7-7"
            />
          </svg>
        )}
      </div>
      {open && (
        <div className={"grid grid-cols-5 gap-y-1 pt-0 p-3 bg-white "}>
          <Content
            classNameValue={"text-red-400"}
            label="รวม"
            value={`${getFixedTotal()}`}
          />
          <Content
            classNameValue={"text-red-400"}
            label="ค่ายกเลิกสัญญา"
            value={`${getNumber(loan?.break_fee) || 0}`}
          />
          <Content
            classNameValue={"text-red-400"}
            label="เงินต้น"
            value={`${getNumber(loan?.cancel_total_principle) || 0}`}
          />
          <Content
            classNameValue={"text-red-400"}
            label="เงินต้นภาษี"
            value={`${getNumber(loan?.cancel_total_principle_vat) || 0}`}
          />
          <Content
            classNameValue={"text-red-400"}
            label="ดอกเบี้ย"
            value={`${getNumber(loan?.cancel_total_interest) || 0}`}
          />
          <Content
            classNameValue={"text-red-400"}
            label="ดอกเบี้ยภาษี"
            value={`${getNumber(loan?.cancel_total_interest_vat) || 0}`}
          />
          <Content
            classNameValue={"text-red-400"}
            label="ดอกเบี้ยผิดนัด"
            value={`${getNumber(loan?.cancel_total_penalty) || 0}`}
          />
          <Content
            classNameValue={"text-red-400"}
            label="ทวงถาม"
            value={`${getNumber(loan?.cancel_total_demand_fee) || 0}`}
          />
          <Content
            classNameValue={"text-red-400"}
            label="ลงพื้นที่"
            value={`${getNumber(loan?.cancel_total_visit_fee) || 0}`}
          />
          <Content
            classNameValue={"text-red-400"}
            label="ภาษี (SAP)"
            value={`${
              getNumber(
                loan?.cancel_total_principle_vat_sap +
                  loan?.cancel_total_interest_vat_sap
              ) || 0
            }`}
          />
          <Content
            classNameValue={"text-red-400"}
            label="ดอกเบี้ย (SAP)"
            value={`${getNumber(loan?.cancel_total_interest_sap) || 0}`}
          />
        </div>
      )}
    </div>
  );
};

export default FootageFeeData;
